import { AssetImage } from "../AssetImage";

export const DEALERS = {
  CLASSIC: { name: "Celeste", asset: "dealer_female_01" },
  MODERN: { name: "Marco", asset: "dealer_male_01" },
};
export const useDealerSkin = () => {
  const k = localStorage.getItem("pfp_dealer");
  return k && DEALERS[k] ? k : "CLASSIC";
};

const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

// Rendered BEHIND the table art so the rail/chip rack hides the lower torso: the dealer sits in the notch.
// target = [x%, y%] of the seat the action is on (table coords); null = looks at the room
export const DealerPortrait = ({ skin, target, speaking }) => {
  const d = DEALERS[skin] || DEALERS.CLASSIC;
  const dx = target ? (target[0] - 50) / 50 : 0; // -1..1
  const lean = clamp(dx * 6, -6, 6);
  const shift = dx * 10;
  return (
    <div data-testid="dealer-avatar" className="absolute left-1/2 -translate-x-1/2" style={{ top: "-27%", height: "44%" }}>
      <div className="h-full dealer-idle" style={{ transformOrigin: "50% 100%", transform: `rotate(${lean}deg) translateX(${shift}px) ${speaking ? "scale(1.03)" : ""}`, transition: "transform 700ms cubic-bezier(.2,.8,.2,1)" }}>
        <AssetImage id={d.asset} className="h-full w-auto" style={{ filter: "drop-shadow(0 8px 14px rgba(0,0,0,0.6))" }} data-testid="dealer-portrait" />
      </div>
    </div>
  );
};

// Rendered ABOVE the table art, to the dealer's right.
export const DealerBubble = ({ skin, line }) => {
  const d = DEALERS[skin] || DEALERS.CLASSIC;
  if (!line) return null;
  return (
    <div key={line} data-testid="dealer-bubble" className="dealer-bubble absolute glass rounded-2xl px-4 py-2 max-w-[320px] text-sm text-slate-100 rise" style={{ left: "58%", top: "-12%" }}>
      <span className="text-[10px] uppercase tracking-[0.25em] text-amber-300 block">{d.name}</span>
      {line}
      <span className="absolute -left-2 bottom-4 w-0 h-0 border-y-8 border-y-transparent border-r-8 border-r-slate-700/80" />
    </div>
  );
};
